import { cn } from "@/lib/utils";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
};

export const ToggleSwitch = ({ checked, onChange, label, description }: Props) => (
  <div className="flex items-center justify-between mb-3 lg:mb-5 px-3.5 py-2.5 bg-[#F9FAFB] rounded-lg border border-[#E5E7EB]">
    <div>
      <p className="text-[0.8125rem] font-medium text-[#374151] m-0">{label}</p>
      {description && (
        <p className="text-[0.7rem] text-[#9CA3AF] mt-[0.1rem] mb-0 hidden lg:block">
          {description}
        </p>
      )}
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={cn(
        "relative shrink-0 w-11 h-6 rounded-full border-none cursor-pointer transition-colors duration-200",
        checked ? "bg-brand-pink" : "bg-gray-300",
      )}
    >
      <span
        className="absolute top-0.5 w-5 h-5 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.2)] transition-[left] duration-200 block"
        style={{ left: checked ? "calc(100% - 1.375rem)" : "0.125rem" }}
      />
    </button>
  </div>
);
